export const QA_NAME_CALENDAR_SECTION = 'calendarSection'
